import {
  ADD_USERINSTRUCTION_TYPE,
  CLEAR_USERINSTRUCTION_TYPE,
  USER_DETAILS_DATA,
  GET_ALL_DETAILS_TABS,
  CLEAR_USERINSTRUCTION_TAB_TYPE,
  GET_USER_INSTRUCTION_CARE_GROUP,
  GET_GROUP_USER_INSTRUCTION_DETAILS,
  USER_DETAILS_GROUP_DATA,
  CHECK_UNIQUE_PRODUCT_TYPE,
  GET_CARE_LIBRARIES,
  GET_ALL_COLUMNS,
} from './UserInstruction.type';

const initialState = {
  userInstructionList: [],
  totalRecords: 0,
  columns: [],
  tabData: [],
  totalDataRecords: 0,
  careUserGroupList: [],
  groupUserInstructionDetails: null,
  tabColumns: [],
  productTypeData: [],
  careLibraries: {},
  allColumns: [],
  existingCareGrpCombination: [],
};

const UserInstructionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_USERINSTRUCTION_TYPE:
      return {
        ...state,
        userInstructionList: [...(state?.userInstructionList || []), ...(action?.payload?.data || [])],
        totalRecords: action?.payload?.totalCount,
      };
    case CLEAR_USERINSTRUCTION_TYPE:
      return {
        ...state,
        userInstructionList: [],
        totalRecords: 0,
      };
    case CLEAR_USERINSTRUCTION_TAB_TYPE:
      return {
        ...state,
        tabData: [],
        totalDataRecords: 0,
      };
    case USER_DETAILS_DATA: {
      return {
        ...state,
        columns: action?.payload,
      };
    }
    case GET_ALL_DETAILS_TABS: {
      return {
        ...state,
        tabData: action?.payload,
      };
    }
    case GET_USER_INSTRUCTION_CARE_GROUP: {
      return {
        ...state,
        careUserGroupList: action?.payload,
      };
    }
    case GET_GROUP_USER_INSTRUCTION_DETAILS: {
      return {
        ...state,
        groupUserInstructionDetails: action?.payload,
      };
    }
    case USER_DETAILS_GROUP_DATA: {
      return {
        ...state,
        tabColumns: action?.payload,
      };
    }
    case CHECK_UNIQUE_PRODUCT_TYPE: {
      return {
        ...state,
        existingCareGrpCombination: action?.payload,
      };
    }
    case GET_CARE_LIBRARIES: {
      return {
        ...state,
        careLibraries: action?.payload,
      };
    }
    case GET_ALL_COLUMNS: {
      return {
        ...state,
        allColumns: action?.payload,
      };
    }
    default:
      return state;
  }
};

export default UserInstructionReducer;
